



















































import Vue, { PropType } from "vue";
import { UserReports } from "@/api/types";
import CompanyLogo from "@/components/Atoms/CompanyLogo/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Rates from "@/components/Molecules/Rates/index.vue";
import { numberWithCommas } from "@/helpers/format-helper";
import { PartiallyPartial } from "@/helpers/type-helper";

import { ApiResponse } from "@/api/types";

export interface Data {}
export interface Computed {}
export interface Props {
  companies: PartiallyPartial<
    Pick<
      ApiResponse.CompanyDetail,
      "id" | "name" | "square_logo_url" | "rating" | "user_reports"
    >,
    "square_logo_url" | "rating" | "user_reports"
  >[];
  isComparedAverage: boolean;
}
export interface Methods {
  getReviewCountText: (
    userReports: ApiResponse.CompanyDetail["user_reports"]
  ) => string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "CompanyInfos",
  components: {
    CompanyLogo,
    Heading,
    Rates
  },
  props: {
    companies: {
      type: Array as PropType<Props["companies"]>,
      required: true
    },
    isComparedAverage: {
      type: Boolean as PropType<Props["isComparedAverage"]>,
      default: false
    }
  },
  methods: {
    getReviewCountText(userReports) {
      const count = userReports.reduce((acc: number, cur: UserReports) => {
        return acc + cur.count;
      }, 0);
      return count ? `${numberWithCommas(count)}件` : "0件";
    }
  }
});
